import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Bell, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PushBanner = () => {
  const { user, isAuthenticated, updateUser } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [enabling, setEnabling] = useState(false);

  // Don't show if: not logged in, already enabled, dismissed this session, on setup page
  if (!isAuthenticated || !user) return null;
  if (user.notifications_enabled) return null;
  if (dismissed) return null;
  if (window.location.pathname.includes('/profile/setup') || window.location.pathname.includes('/admin')) return null;

  // Check if dismissed recently (show max once per day)
  const lastDismissed = localStorage.getItem('push_banner_dismissed_at');
  if (lastDismissed && (Date.now() - parseInt(lastDismissed)) < 24 * 60 * 60 * 1000) return null;

  const handleEnable = async () => {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return;
    setEnabling(true);
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const registration = await navigator.serviceWorker.register('/sw.js');
        await navigator.serviceWorker.ready;
        const vapidRes = await axios.get(`${API}/notifications/vapid-key`);
        const key = vapidRes.data.publicKey;
        const padding = '='.repeat((4 - key.length % 4) % 4);
        const b64 = (key + padding).replace(/-/g, '+').replace(/_/g, '/');
        const raw = atob(b64);
        const arr = new Uint8Array(raw.length);
        for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
        const sub = await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: arr });
        await axios.post(`${API}/notifications/subscribe`, sub.toJSON());
        updateUser({ notifications_enabled: true });
      }
    } catch (e) {
      /* silent */
    }
    setEnabling(false);
    setDismissed(true);
  };

  const handleDismiss = () => {
    localStorage.setItem('push_banner_dismissed_at', Date.now().toString());
    setDismissed(true);
  };

  return (
    <div data-testid="push-banner" style={{
      position: 'fixed', bottom: 72, left: 12, right: 12, zIndex: 1000,
      background: 'linear-gradient(135deg, #0F3B2E 0%, #1a4d3e 100%)',
      borderRadius: 14, padding: '12px 16px',
      display: 'flex', alignItems: 'center', gap: 10,
      boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
      border: '1px solid rgba(201,169,78,0.2)',
    }}>
      <Bell size={18} color="#c9a94e" style={{ flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ color: '#f5f0e8', fontSize: 13, fontWeight: 600, margin: 0 }}>
          Never miss a match
        </p>
        <p style={{ color: '#94a3b8', fontSize: 11, margin: 0 }}>
          Turn on notifications to get alerts
        </p>
      </div>
      <button
        onClick={handleEnable}
        disabled={enabling}
        style={{
          padding: '6px 14px', borderRadius: 20,
          background: '#c9a94e', color: '#0F3B2E',
          fontSize: 12, fontWeight: 700, border: 'none',
          cursor: enabling ? 'wait' : 'pointer', flexShrink: 0,
        }}
      >
        {enabling ? '...' : 'Enable'}
      </button>
      <button onClick={handleDismiss} style={{
        background: 'none', border: 'none', cursor: 'pointer',
        padding: 4, flexShrink: 0,
      }}>
        <X size={16} color="#64748b" />
      </button>
    </div>
  );
};

export default PushBanner;
